import { CombinedGraphQLErrors } from '@apollo/client';
import type { GraphQLFormattedError } from 'graphql';

/**
 * Error extending base Error. It supports adding correlation ID that can be used when displaying error messages.
 */
export class CorrelationIdError extends Error {
	private readonly correlationIdMessageTemplate = 'If you need assistance, please contact support and provide this reference ID: ';

	public correlationIdMessage = '';

	public readonly graphQLErrors?: readonly GraphQLFormattedError[];

	public readonly networkError?: unknown;

	/**
	 * Constructor.
	 * @param error Original error.
	 * @param correlationId Correlation ID of source request.
	 */
	constructor(
		error: unknown,
		public readonly correlationId?: string,
	) {
		super('Apollo request failed');
		this.name = 'CorrelationIdError';

		if (CombinedGraphQLErrors.is(error)) {
			this.graphQLErrors = error.errors;
		} else {
			this.networkError = error;
		}

		(this as any).correlationId = correlationId;
		(this as any).originalError = error;
		(this as any).correlationIdMessage = `${this.correlationIdMessageTemplate}${correlationId}`;
	}
}
